import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
import App from './App';
import router from './router';
import store from './store';
import mixins from './mixins/index';

Vue.config.productionTip = false;
const options = {
  confirmButtonColor: '#252f4e',
  cancelButtonColor: '#572a35',
};

Vue.use(VueSweetalert2, options);
Vue.use(require('vue-moment'));

// Define authentication route access rules
router.beforeEach((to, from, next) => {
  const auth = localStorage.getObject('auth');
  if (to.meta.auth) {
    if (auth && auth.accessToken) {
      next();
    } else {
      next({ name: 'auth' });
    }
  }
  if (to.name === 'auth' && auth && auth.accessToken) {
    next({ name: 'dashboard>rules' });
  }
  next();
});

// Globally
Vue.mixin(mixins.service);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js